import fetchData from '../fetch/index.tsx';

const fetchIssueCreate = () => fetchData('issue-create');

export default fetchIssueCreate;
